// Sample location data - you can expand this with more countries/states/districts
export const locationData = {
  countries: [
  { id: 'af', name: 'Afghanistan' },
  { id: 'al', name: 'Albania' },
  { id: 'dz', name: 'Algeria' },
  { id: 'ad', name: 'Andorra' },
  { id: 'ao', name: 'Angola' },
  { id: 'ag', name: 'Antigua and Barbuda' },
  { id: 'ar', name: 'Argentina' },
  { id: 'am', name: 'Armenia' },
  { id: 'au', name: 'Australia' },
  { id: 'at', name: 'Austria' },
  { id: 'az', name: 'Azerbaijan' },
  { id: 'bs', name: 'Bahamas' },
  { id: 'bh', name: 'Bahrain' },
  { id: 'bd', name: 'Bangladesh' },
  { id: 'bb', name: 'Barbados' },
  { id: 'by', name: 'Belarus' },
  { id: 'be', name: 'Belgium' },
  { id: 'bz', name: 'Belize' },
  { id: 'bj', name: 'Benin' },
  { id: 'bt', name: 'Bhutan' },
  { id: 'bo', name: 'Bolivia' },
  { id: 'ba', name: 'Bosnia and Herzegovina' },
  { id: 'bw', name: 'Botswana' },
  { id: 'br', name: 'Brazil' },
  { id: 'bn', name: 'Brunei' },
  { id: 'bg', name: 'Bulgaria' },
  { id: 'bf', name: 'Burkina Faso' },
  { id: 'bi', name: 'Burundi' },
  { id: 'cv', name: 'Cabo Verde' },
  { id: 'kh', name: 'Cambodia' },
  { id: 'cm', name: 'Cameroon' },
  { id: 'ca', name: 'Canada' },
  { id: 'cf', name: 'Central African Republic' },
  { id: 'td', name: 'Chad' },
  { id: 'cl', name: 'Chile' },
  { id: 'cn', name: 'China' },
  { id: 'co', name: 'Colombia' },
  { id: 'km', name: 'Comoros' },
  { id: 'cg', name: 'Congo' },
  { id: 'cd', name: 'Congo (Democratic Republic)' },
  { id: 'cr', name: 'Costa Rica' },
  { id: 'ci', name: "Côte d’Ivoire" },
  { id: 'hr', name: 'Croatia' },
  { id: 'cu', name: 'Cuba' },
  { id: 'cy', name: 'Cyprus' },
  { id: 'cz', name: 'Czechia' },
  { id: 'dk', name: 'Denmark' },
  { id: 'dj', name: 'Djibouti' },
  { id: 'dm', name: 'Dominica' },
  { id: 'do', name: 'Dominican Republic' },
  { id: 'ec', name: 'Ecuador' },
  { id: 'eg', name: 'Egypt' },
  { id: 'sv', name: 'El Salvador' },
  { id: 'gq', name: 'Equatorial Guinea' },
  { id: 'er', name: 'Eritrea' },
  { id: 'ee', name: 'Estonia' },
  { id: 'sz', name: 'Eswatini' },
  { id: 'et', name: 'Ethiopia' },
  { id: 'fj', name: 'Fiji' },
  { id: 'fi', name: 'Finland' },
  { id: 'fr', name: 'France' },
  { id: 'ga', name: 'Gabon' },
  { id: 'gm', name: 'Gambia' },
  { id: 'ge', name: 'Georgia' },
  { id: 'de', name: 'Germany' },
  { id: 'gh', name: 'Ghana' },
  { id: 'gr', name: 'Greece' },
  { id: 'gd', name: 'Grenada' },
  { id: 'gt', name: 'Guatemala' },
  { id: 'gn', name: 'Guinea' },
  { id: 'gw', name: 'Guinea-Bissau' },
  { id: 'gy', name: 'Guyana' },
  { id: 'ht', name: 'Haiti' },
  { id: 'hn', name: 'Honduras' },
  { id: 'hu', name: 'Hungary' },
  { id: 'is', name: 'Iceland' },
  { id: 'in', name: 'India' },
  { id: 'id', name: 'Indonesia' },
  { id: 'ir', name: 'Iran' },
  { id: 'iq', name: 'Iraq' },
  { id: 'ie', name: 'Ireland' },
  { id: 'il', name: 'Israel' },
  { id: 'it', name: 'Italy' },
  { id: 'jm', name: 'Jamaica' },
  { id: 'jp', name: 'Japan' },
  { id: 'jo', name: 'Jordan' },
  { id: 'kz', name: 'Kazakhstan' },
  { id: 'ke', name: 'Kenya' },
  { id: 'ki', name: 'Kiribati' },
  { id: 'kp', name: 'North Korea' },
  { id: 'kr', name: 'South Korea' },
  { id: 'kw', name: 'Kuwait' },
  { id: 'kg', name: 'Kyrgyzstan' },
  { id: 'la', name: 'Laos' },
  { id: 'lv', name: 'Latvia' },
  { id: 'lb', name: 'Lebanon' },
  { id: 'ls', name: 'Lesotho' },
  { id: 'lr', name: 'Liberia' },
  { id: 'ly', name: 'Libya' },
  { id: 'li', name: 'Liechtenstein' },
  { id: 'lt', name: 'Lithuania' },
  { id: 'lu', name: 'Luxembourg' },
  { id: 'mg', name: 'Madagascar' },
  { id: 'mw', name: 'Malawi' },
  { id: 'my', name: 'Malaysia' },
  { id: 'mv', name: 'Maldives' },
  { id: 'ml', name: 'Mali' },
  { id: 'mt', name: 'Malta' },
  { id: 'mh', name: 'Marshall Islands' },
  { id: 'mr', name: 'Mauritania' },
  { id: 'mu', name: 'Mauritius' },
  { id: 'mx', name: 'Mexico' },
  { id: 'fm', name: 'Micronesia' },
  { id: 'md', name: 'Moldova' },
  { id: 'mc', name: 'Monaco' },
  { id: 'mn', name: 'Mongolia' },
  { id: 'me', name: 'Montenegro' },
  { id: 'ma', name: 'Morocco' },
  { id: 'mz', name: 'Mozambique' },
  { id: 'mm', name: 'Myanmar' },
  { id: 'na', name: 'Namibia' },
  { id: 'nr', name: 'Nauru' },
  { id: 'np', name: 'Nepal' },
  { id: 'nl', name: 'Netherlands' },
  { id: 'nz', name: 'New Zealand' },
  { id: 'ni', name: 'Nicaragua' },
  { id: 'ne', name: 'Niger' },
  { id: 'ng', name: 'Nigeria' },
  { id: 'mk', name: 'North Macedonia' },
  { id: 'no', name: 'Norway' },
  { id: 'om', name: 'Oman' },
  { id: 'pk', name: 'Pakistan' },
  { id: 'pw', name: 'Palau' },
  { id: 'ps', name: 'Palestine' },
  { id: 'pa', name: 'Panama' },
  { id: 'pg', name: 'Papua New Guinea' },
  { id: 'py', name: 'Paraguay' },
  { id: 'pe', name: 'Peru' },
  { id: 'ph', name: 'Philippines' },
  { id: 'pl', name: 'Poland' },
  { id: 'pt', name: 'Portugal' },
  { id: 'qa', name: 'Qatar' },
  { id: 'ro', name: 'Romania' },
  { id: 'ru', name: 'Russia' },
  { id: 'rw', name: 'Rwanda' },
  { id: 'kn', name: 'Saint Kitts and Nevis' },
  { id: 'lc', name: 'Saint Lucia' },
  { id: 'vc', name: 'Saint Vincent and the Grenadines' },
  { id: 'ws', name: 'Samoa' },
  { id: 'sm', name: 'San Marino' },
  { id: 'st', name: 'Sao Tome and Principe' },
  { id: 'sa', name: 'Saudi Arabia' },
  { id: 'sn', name: 'Senegal' },
  { id: 'rs', name: 'Serbia' },
  { id: 'sc', name: 'Seychelles' },
  { id: 'sl', name: 'Sierra Leone' },
  { id: 'sg', name: 'Singapore' },
  { id: 'sk', name: 'Slovakia' },
  { id: 'si', name: 'Slovenia' },
  { id: 'sb', name: 'Solomon Islands' },
  { id: 'so', name: 'Somalia' },
  { id: 'za', name: 'South Africa' },
  { id: 'ss', name: 'South Sudan' },
  { id: 'es', name: 'Spain' },
  { id: 'lk', name: 'Sri Lanka' },
  { id: 'sd', name: 'Sudan' },
  { id: 'sr', name: 'Suriname' },
  { id: 'se', name: 'Sweden' },
  { id: 'ch', name: 'Switzerland' },
  { id: 'sy', name: 'Syria' },
  { id: 'tj', name: 'Tajikistan' },
  { id: 'tz', name: 'Tanzania' },
  { id: 'th', name: 'Thailand' },
  { id: 'tl', name: 'Timor-Leste' },
  { id: 'tg', name: 'Togo' },
  { id: 'to', name: 'Tonga' },
  { id: 'tt', name: 'Trinidad and Tobago' },
  { id: 'tn', name: 'Tunisia' },
  { id: 'tr', name: 'Turkey' },
  { id: 'tm', name: 'Turkmenistan' },
  { id: 'tv', name: 'Tuvalu' },
  { id: 'ug', name: 'Uganda' },
  { id: 'ua', name: 'Ukraine' },
  { id: 'ae', name: 'United Arab Emirates' },
  { id: 'gb', name: 'United Kingdom' },
  { id: 'us', name: 'United States' },
  { id: 'uy', name: 'Uruguay' },
  { id: 'uz', name: 'Uzbekistan' },
  { id: 'vu', name: 'Vanuatu' },
  { id: 've', name: 'Venezuela' },
  { id: 'vn', name: 'Vietnam' },
  { id: 'ye', name: 'Yemen' },
  { id: 'zm', name: 'Zambia' },
  { id: 'zw', name: 'Zimbabwe' }
],
  states: {
    in: [
      // States
{ id: 'ap', name: 'Andhra Pradesh' },
{ id: 'ar', name: 'Arunachal Pradesh' },
{ id: 'as', name: 'Assam' },
{ id: 'br', name: 'Bihar' },
{ id: 'ct', name: 'Chhattisgarh' },
{ id: 'ga', name: 'Goa' },
{ id: 'gj', name: 'Gujarat' },
{ id: 'hr', name: 'Haryana' },
{ id: 'hp', name: 'Himachal Pradesh' },
{ id: 'jh', name: 'Jharkhand' },
{ id: 'ka', name: 'Karnataka' },
{ id: 'kl', name: 'Kerala' },
{ id: 'mp', name: 'Madhya Pradesh' },
{ id: 'mh', name: 'Maharashtra' },
{ id: 'mn', name: 'Manipur' },
{ id: 'ml', name: 'Meghalaya' },
{ id: 'mz', name: 'Mizoram' },
{ id: 'nl', name: 'Nagaland' },
{ id: 'or', name: 'Odisha' },
{ id: 'pb', name: 'Punjab' },
{ id: 'rj', name: 'Rajasthan' },
{ id: 'sk', name: 'Sikkim' },
{ id: 'tn', name: 'Tamil Nadu' },
{ id: 'tg', name: 'Telangana' },
{ id: 'tr', name: 'Tripura' },
{ id: 'up', name: 'Uttar Pradesh' },
{ id: 'uk', name: 'Uttarakhand' },
{ id: 'wb', name: 'West Bengal' },

// Union Territories
{ id: 'an', name: 'Andaman and Nicobar Islands' },
{ id: 'ch', name: 'Chandigarh' },
{ id: 'dn', name: 'Dadra and Nagar Haveli and Daman and Diu' },
{ id: 'dl', name: 'Delhi' },
{ id: 'jk', name: 'Jammu and Kashmir' },
{ id: 'la', name: 'Ladakh' },
{ id: 'ld', name: 'Lakshadweep' },
{ id: 'py', name: 'Puducherry' }

    ],
    us: [
      { id: 'ca', name: 'California' },
      { id: 'tx', name: 'Texas' },
      { id: 'ny', name: 'New York' },
      { id: 'fl', name: 'Florida' }
    ],
    uk: [
      { id: 'eng', name: 'England' },
      { id: 'sct', name: 'Scotland' },
      { id: 'wls', name: 'Wales' },
      { id: 'nir', name: 'Northern Ireland' }
    ],
    ca: [
      { id: 'on', name: 'Ontario' },
      { id: 'bc', name: 'British Columbia' },
      { id: 'qc', name: 'Quebec' },
      { id: 'ab', name: 'Alberta' }
    ],
    au: [
      { id: 'nsw', name: 'New South Wales' },
      { id: 'vic', name: 'Victoria' },
      { id: 'qld', name: 'Queensland' },
      { id: 'wa', name: 'Western Australia' }
    ]
  },

  
  
  districts: {
    // Tamil Nadu Districts
    tn: [
  { id: 'ariyalur', name: 'Ariyalur' },
  { id: 'chengalpattu', name: 'Chengalpattu' },
  { id: 'chennai', name: 'Chennai' },
  { id: 'coimbatore', name: 'Coimbatore' },
  { id: 'cuddalore', name: 'Cuddalore' },
  { id: 'dharmapuri', name: 'Dharmapuri' },
  { id: 'dindigul', name: 'Dindigul' },
  { id: 'erode', name: 'Erode' },
  { id: 'kallakurichi', name: 'Kallakurichi' },
  { id: 'kancheepuram', name: 'Kancheepuram' },
  { id: 'karur', name: 'Karur' },
  { id: 'krishnagiri', name: 'Krishnagiri' },
  { id: 'madurai', name: 'Madurai' },
  { id: 'nagapattinam', name: 'Nagapattinam' },
  { id: 'namakkal', name: 'Namakkal' },
  { id: 'nilgiris', name: 'Nilgiris' },
  { id: 'perambalur', name: 'Perambalur' },
  { id: 'pudukkottai', name: 'Pudukkottai' },
  { id: 'ramanathapuram', name: 'Ramanathapuram' },
  { id: 'ranipet', name: 'Ranipet' },
  { id: 'salem', name: 'Salem' },
  { id: 'sivaganga', name: 'Sivaganga' },
  { id: 'tenkasi', name: 'Tenkasi' },
  { id: 'thanjavur', name: 'Thanjavur' },
  { id: 'theni', name: 'Theni' },
  { id: 'thoothukudi', name: 'Thoothukudi' },
  { id: 'tiruchirappalli', name: 'Tiruchirappalli' },
  { id: 'tirunelveli', name: 'Tirunelveli' },
  { id: 'tirupathur', name: 'Tirupathur' },
  { id: 'tiruppur', name: 'Tiruppur' },
  { id: 'tiruvallur', name: 'Tiruvallur' },
  { id: 'tiruvannamalai', name: 'Tiruvannamalai' },
  { id: 'tiruvarur', name: 'Tiruvarur' },
  { id: 'vellore', name: 'Vellore' },
  { id: 'viluppuram', name: 'Viluppuram' },
  { id: 'virudhunagar', name: 'Virudhunagar' },
  { id: 'mayiladuthurai', name: 'Mayiladuthurai' }
],
    // Maharashtra Districts
   mh: [
  { id: 'ahmednagar', name: 'Ahmednagar' },
  { id: 'akola', name: 'Akola' },
  { id: 'amravati', name: 'Amravati' },
  { id: 'aurangabad', name: 'Aurangabad' },
  { id: 'beed', name: 'Beed' },
  { id: 'bhandara', name: 'Bhandara' },
  { id: 'buldhana', name: 'Buldhana' },
  { id: 'chandrapur', name: 'Chandrapur' },
  { id: 'dhule', name: 'Dhule' },
  { id: 'gadchiroli', name: 'Gadchiroli' },
  { id: 'gondia', name: 'Gondia' },
  { id: 'hingoli', name: 'Hingoli' },
  { id: 'jalgaon', name: 'Jalgaon' },
  { id: 'jalna', name: 'Jalna' },
  { id: 'kolhapur', name: 'Kolhapur' },
  { id: 'latur', name: 'Latur' },
  { id: 'mumbai_city', name: 'Mumbai City' },
  { id: 'mumbai_suburban', name: 'Mumbai Suburban' },
  { id: 'nagpur', name: 'Nagpur' },
  { id: 'nanded', name: 'Nanded' },
  { id: 'nandurbar', name: 'Nandurbar' },
  { id: 'nashik', name: 'Nashik' },
  { id: 'osmanabad', name: 'Osmanabad' },
  { id: 'palghar', name: 'Palghar' },
  { id: 'parbhani', name: 'Parbhani' },
  { id: 'pune', name: 'Pune' },
  { id: 'raigad', name: 'Raigad' },
  { id: 'ratnagiri', name: 'Ratnagiri' },
  { id: 'sangli', name: 'Sangli' },
  { id: 'satara', name: 'Satara' },
  { id: 'sindhudurg', name: 'Sindhudurg' },
  { id: 'solapur', name: 'Solapur' },
  { id: 'thane', name: 'Thane' },
  { id: 'wardha', name: 'Wardha' },
  { id: 'washim', name: 'Washim' },
  { id: 'yavatmal', name: 'Yavatmal' }
],
    // Karnataka Districts
    ka: [
      { id: 'bangalore', name: 'Bangalore' },
      { id: 'mysore', name: 'Mysore' },
      { id: 'mangalore', name: 'Mangalore' },
      { id: 'hubli', name: 'Hubli' }
    ],
    // US States - California
    ca: [
      { id: 'los_angeles', name: 'Los Angeles' },
      { id: 'san_francisco', name: 'San Francisco' },
      { id: 'san_diego', name: 'San Diego' },
      { id: 'sacramento', name: 'Sacramento' }
    ],
    // UK - England
    eng: [
      { id: 'london', name: 'London' },
      { id: 'manchester', name: 'Manchester' },
      { id: 'birmingham', name: 'Birmingham' },
      { id: 'liverpool', name: 'Liverpool' }
    ],
    // Add more districts for other states as needed
  }
};

// Helper functions to get data
export const getStatesByCountry = (countryId) => {
  return locationData.states[countryId] || [];
};

export const getDistrictsByState = (stateId) => {
  return locationData.districts[stateId] || [];
};

export const getAllCountries = () => {
  return locationData.countries;
};